module.exports = __webpack_public_path__ + "img/home.5947e846.png";